import fullscreenAPI from "../utils/fullscreen-api"
import { hideEndDisplay } from "./end-display"
import store from "./player-store"
import { fullscreenOverlay, player, toolbar } from "./selectors"
import { clearTrackers, scrollToSlide } from "./player-navigation"
import logEvent from "../tracking/amplitude/log-event"

const icon = $(".fullscreen-icon")

const enterFullscreen = () => {
  const currentIndex = store.index

  clearTrackers()

  hideEndDisplay()
  player.addClass("fullscreen")
  toolbar.hide()
  fullscreenAPI.requestNativeFullscreen(player[0])

  setTimeout(() => {
    scrollToSlide(currentIndex, true)
  }, 400)

  icon.removeClass("icon-focus").addClass("icon-compress")
}

const exitFullscreen = () => {
  const currentIndex = store.index

  clearTrackers()

  hideEndDisplay()
  player.removeClass("fullscreen")
  fullscreenOverlay.hide()
  toolbar.show()
  if (fullscreenAPI.isFullscreen) {
    fullscreenAPI.exitNativeFullscreen()
  }

  setTimeout(() => {
    scrollToSlide(currentIndex, true)
  }, 400)

  icon.removeClass("icon-compress").addClass("icon-focus")
}

const bindEventListeners = () => {
  $("button#fullscreen").on("click", function () {
    if (fullscreenAPI.isFullscreen) {
      logEvent("slideshow_fullscreen_click", { click_type: "close" })
      exitFullscreen()
    } else {
      logEvent("slideshow_fullscreen_click", { click_type: "open" })
      enterFullscreen()
    }
  })

  $("#exit-fullscreen").on("click", function (e) {
    e.preventDefault()
    e.stopPropagation()
    if (fullscreenAPI.isFullscreen) {
      logEvent("slideshow_fullscreen_click", { click_type: "close" })
      exitFullscreen()
    }
  })

  $("#new-player").on("click", function () {
    if (fullscreenAPI.isFullscreen) {
      if (fullscreenOverlay.is(":visible")) {
        fullscreenOverlay.hide()
      } else {
        fullscreenOverlay.show()
      }
    }
  })

  fullscreenAPI.addEventListener("fullscreenchange", () => {
    // After a keyboard-triggered exit event, isFullscreen will return false
    if (!fullscreenAPI.isFullscreen) {
      exitFullscreen()
    }
  })
}

export const initializeFullscreen = () => {
  if (fullscreenAPI.isFullscreenModeSupported) {
    bindEventListeners()
  } else {
    icon.hide()
  }
}
